{
  "addSupplier": {
    "stepper": {
      "title": "Add Supplier",
      "steps": {
        "generalInfo": {
          "title": "General info",
          "description": "Enter general supplier information"
        },
        "riskAssessment": {
          "title": "Risk assessment",
          "description": "Select the supplier risk level"
        },
        "supportingDocuments": {
          "title": "Supporting documents",
          "description": "Upload or link required documentation"
        },
        "approval": {
          "title": "Approval",
          "description": "Check all information and send the supplier for approval"
        }
      },
      "buttons": {
        "saveAsDraft": "Save as draft and exit",
        "cancel": "Cancel",
        "previous": "Previous",
        "next": "Next",
        "sendForApproval": "Send for approval"
      }
    },
    "generalInfo": {
      "heading": "General info",
      "fields": {
        "supplierName": {
          "label": "Supplier name*",
          "helper": "This field is required when sending for approval."
        },
        "supplierType": {
          "label": "Supplier type",
          "helper": "This field is required when sending for approval."
        },
        "website": {
          "label": "Website"
        },
        "intendedUse": {
          "label": "Intended use"
        },
        "sponsor": {
          "label": "Sponsor",
          "helper": "This field is required when sending for approval."
        }
      },
      "contactInfo": {
        "heading": "Supplier's contact information",
        "fields": {
          "name": "Name",
          "email": "Email",
          "phone": "Phone",
          "address": "Address",
          "notes": "Notes"
        }
      },
      "warnings": {
        "invalidFields": "You seem to have some fields with invalid values."
      }
    },
    "riskAssessment": {
      "heading": "Risk assessment",
      "description": "Risk levels are defined by the supplier policy. If you are unsure now you can come back to it later. Note that risk level is needed to assign the right supporting documents as required by the policy."
    },
    "supportingDocuments": {
      "heading": "Supporting documents",
      "alerts": {
        "selectTypeAndRisk": "Select supplier type and risk level to see which documents are required.",
        "noMandatoryDocuments": "Your supplier policy does not require any mandatory documents for the supplier type {{type}} and the risk level {{level}}.",
        "documentsMovedTitle": "Documents moved to \"Additional documents\"",
        "documentsMovedDescription": "Each risk level may require different documents. Because the risk level was changed, all documents have been moved to \"Additional documents\". To reuse them, download and add them to the required documents. These changes will take effect when you save the supplier."
      },
      "policyText": "Your supplier policy requires the following documents for the supplier type {{type}} and the risk level {{level}}.",
      "additionalDocumentsInfo": "Include any additional documentation that is relevant for this supplier."
    },
    "approval": {
      "heading": "Approval",
      "infoText": "Review supplier information before sending it for approval.",
      "sections": {
        "generalInformation": "General information",
        "supplierContactInformation": "Supplier contact information",
        "riskLevel": "Risk level",
        "supportingDocuments": "Supporting documents",
        "additionalDocuments": "Additional documents",
        "requiredAudits": "Required audits",
        "approval": "Approval"
      },
      "fields": {
        "supplierName": "Supplier name",
        "supplierType": "Supplier type",
        "website": "Website",
        "intendedUse": "Intended use",
        "sponsor": "Sponsor",
        "name": "Name",
        "email": "Email",
        "phone": "Phone",
        "address": "Address",
        "notes": "Notes",
        "approvers": "Approvers"
      },
      "messages": {
        "noMandatoryDocuments": "There are no mandatory documents",
        "noAdditionalDocuments": "There are no additional documents",
        "requiredAuditsPolicy": "For the supplier type {{type}} and the risk level {{level}} your supplier policy requires these audits",
        "noRequiredAuditsPolicy": "For the supplier type {{type}} and the risk level {{level}} your supplier policy does not require any mandatory audits",
        "auditFrequency": "Every {{count}} month(s)",
        "auditOnce": "Only Once",
        "approvalInfo": "Select people who can approve this supplier. At least one quality user should be selected. Only users with access to suppliers can be selected as approvers. Approval will be granted when all of them accept.",
        "auditReviewWarning": "If a review of audits is needed before approval, you can save this supplier and add the audit and all its documents in the \"Audits\" section of this supplier."
      },
      "warnings": {
        "requiredFieldsMissing": "You seem to have some required fields missing or some fields with invalid values"
      },
      "supplierPolicyLink": "supplier policy"
    },
    "modals": {
      "discardChanges": {
        "title": "Discard changes",
        "message": "Are you sure you want to discard your changes to this supplier? You can also save it as draft and finish later.",
        "buttons": {
          "cancel": "Cancel",
          "saveAsDraft": "Save as draft",
          "discardChanges": "Discard changes"
        }
      },
      "cantSaveSupplier": {
        "title": "Can't save supplier",
        "message": "To save this supplier you need to give it a name.",
        "button": "Got it"
      },
      "changeSupplierType": {
        "title": "Change supplier type?",
        "message": "Each risk level may require different documents. All documents will be moved to \"Additional documents\" when you save the supplier.",
        "buttons": {
          "cancel": "Cancel",
          "change": "Change supplier type"
        }
      },
      "changeRiskLevel": {
        "title": "Change risk level?",
        "message": "Each risk level may require different documents. All documents will be moved to \"Additional documents\" when you save the supplier.",
        "buttons": {
          "cancel": "Cancel",
          "change": "Change risk level"
        }
      }
    },
    "validation": {
      "errors": {
        "supplierNameRequired": "Please enter a supplier name",
        "supplierNameEmpty": "Supplier name can not be empty",
        "supplierNameTooLong": "Supplier name can be no longer than 350 characters",
        "supplierTypeRequired": "Please select a supplier type",
        "intendedUseTooLong": "Field Intended use can be no longer than 4000 characters",
        "sponsorRequired": "Please select a Sponsor",
        "contactNotesTooLong": "Field Contact notes can be no longer than 4500 characters",
        "riskTypeRequired": "Please select a risk type",
        "documentsRequired": "Atleast 1 supporting document is required for : {{documentNames}}",
        "approversRequired": "Approvers must be selected",
        "qualityUserRequired": "Approves must contain at least one quality user"
      },
      "fieldNames": {
        "name": "Name",
        "approvers": "Approvers",
        "contactAddress": "Contact address",
        "contactEmail": "Contact email",
        "contactName": "Contact name",
        "contactNotes": "Contact notes",
        "contactPhone": "Contact phone",
        "documents": "Documents",
        "intendedUse": "Intended use",
        "riskType": "Risk type",
        "sponsor": "Sponsor",
        "supplierType": "Supplier type",
        "website": "Website"
      }
    }
  },
  "supplierList": {
    "heading": "Suppliers",
    "buttons": {
      "addSupplier": "Add supplier",
      "import": "Import",
      "exportAsl": "Export ASL",
      "exportCurrentView": "Export current view to CSV",
      "exportFullView": "Export full view to XLSX"
    },
    "search": {
      "placeholder": "Search name"
    },
    "filters": {
      "selectSupplierType": "Select supplier type",
      "selectStatus": "Select status",
      "selectRiskType": "Select risk type",
      "showOnlyArchived": "Show only archived"
    },
    "columns": {
      "name": "Name",
      "type": "Type",
      "status": "Status",
      "risk": "Risk",
      "sponsor": "Sponsor",
      "lastModified": "Last modified",
      "lastAudit": "Last audit",
      "dueIn": "Due in"
    },
    "emptyState": {
      "title": "You don't have any suppliers yet",
      "subtitle": "Before you add a supplier it's recommended to create a supplier policy. The policy will define supplier types you work with, risk levels that will help assess your suppliers and required types of documents each supplier needs to have to be approved.",
      "buttons": {
        "addSupplier": "Add Supplier",
        "importSuppliers": "Import Suppliers",
        "configurePolicy": "Configure Policy"
      },
      "divider": "or"
    },
    "errors": {
      "noApprovedSuppliers": "No approved suppliers to export",
      "cannotRetrievePolicyLinks": "Cannot retrieve policy links"
    }
  },
  "supplierDetails": {
    "buttons": {
      "back": "Back",
      "edit": "Edit",
      "export": "Export",
      "archive": "Archive",
      "unarchive": "Unarchive",
      "revertToDraft": "Revert to draft"
    },
    "tabs": {
      "details": "Details",
      "supportingDocuments": "Supporting documents",
      "audits": "Audits"
    },
    "sections": {
      "riskLevel": "Risk level",
      "generalInfo": "General info",
      "supplierContactInformation": "Supplier contact information"
    },
    "fields": {
      "supplierName": "Supplier name",
      "supplierType": "Supplier type",
      "website": "Website",
      "intendedUse": "Intended use",
      "sponsor": "Sponsor",
      "approvers": "Approvers",
      "createdOn": "Created on",
      "lastModified": "Last modified",
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "address": "Address",
      "notes": "Notes",
      "contactName": "Name",
      "contactEmail": "Email",
      "contactPhone": "Phone",
      "contactAddress": "Address",
      "contactNotes": "Notes"
    },
    "modals": {
      "archive": {
        "title": "Archive",
        "message": "Are you sure you want to archive this supplier? You can unarchive it at any time.",
        "button": "Archive"
      },
      "unarchive": {
        "title": "Unarchive",
        "message": "Are you sure you want to unarchive this supplier? The status will change to \"Draft\".",
        "button": "Unarchive"
      },
      "revertToDraft": {
        "title": "Revert to Draft",
        "message": "Do you want to revert this supplier to the \"Draft\" state?",
        "button": "Revert"
      },
      "export": {
        "title": "Export Supplier",
        "message": "Supplier will be exported as a zip containing :\n- A PDF file with all the supplier details\n- Supporting documents\n- Audit files",
        "button": "Export Supplier"
      }
    }
  },
  "supplierDocuments": {
    "emptyState": {
      "title": "Documents for this supplier will appear here",
      "subtitle": "If your Supplier Policy requires specific documents, edit the supplier to include them here."
    },
    "heading": "Additional documents"
  },
  "supplierAudits": {
    "columns": {
      "name": "Name",
      "auditType": "Audit type",
      "notes": "Notes",
      "addedBy": "Added by",
      "dateCompleted": "Date completed",
      "dateAdded": "Date added",
      "documents": "Documents",
      "filesCount": "{{count}} files"
    },
    "menu": {
      "viewDocuments": "View documents",
      "edit": "Edit",
      "delete": "Delete"
    },
    "emptyState": {
      "title": "Completed audits will appear here",
      "subtitle": "Record the outcome of prior audits with completion date, related files and notes.",
      "button": "Add an audit"
    },
    "buttons": {
      "addAudit": "Add Audit"
    },
    "drawer": {
      "noDocuments": "There are no documents available."
    },
    "modals": {
      "deleteAudit": {
        "title": "Delete Audit",
        "message": "Are you sure you would like to delete this audit?",
        "buttons": {
          "cancel": "Cancel",
          "delete": "Delete audit"
        }
      },
      "addAudit": {
        "title": "Add audit",
        "buttons": {
          "cancel": "Cancel",
          "add": "Add audit"
        }
      },
      "editAudit": {
        "title": "Edit audit",
        "buttons": {
          "cancel": "Cancel",
          "save": "Save audit"
        }
      }
    },
    "nextAudit": {
      "dueTemplate": "Next {{auditType}} Audit is due in {{interval}}",
      "overdueTemplate": "{{auditType}} Audit is {{interval}} overdue",
      "policyRequires": "The supplier policy requires this supplier to be audited with a {{auditType}} audit every {{frequency}} month(s) from the date of last audit ({{lastAuditDate}})",
      "supplierPolicyLink": "supplier policy"
    }
  },
  "createAuditForm": {
    "heading": "Audit information",
    "fields": {
      "auditName": {
        "label": "Audit name*",
        "error": "Please fill out audit name"
      },
      "auditType": {
        "label": "Audit type*",
        "error": "Please fill out audit type"
      },
      "notes": {
        "label": "Notes"
      },
      "completionDate": {
        "label": "Completion date",
        "helper": "The completion date determines the next scheduled audit of this type based on the supplier policy.",
        "placeholder": "dd/mm/yyyy"
      }
    },
    "sections": {
      "auditDocuments": "Audit documents"
    },
    "errors": {
      "fillRequiredFields": "Please fill out required fields"
    }
  },
  "documentCard": {
    "buttons": {
      "addDocument": "Add document",
      "uploadFromComputer": "Upload from computer",
      "qualioDoc": "Qualio doc",
      "download": "Download",
      "open": "Open",
      "delete": "Delete",
      "addDescription": "Add description"
    }
  },
  "qualioDocSelect": {
    "noDocumentFound": "No document found with the prefix:",
    "placeholder": "Please type a valid prefix of a Qualio document. E.g.: \"POL\""
  },
  "importModal": {
    "title": "Import Suppliers",
    "description": "If you store suppliers records as Qualio Docs, you can import them into the Suppliers list. Enter the template prefix of the supplier records",
    "fields": {
      "templatePrefix": {
        "label": "Template prefix",
        "helper": "For example \"SQF\"",
        "button": "Search"
      }
    },
    "messages": {
      "found": "{{count}} supplier records were found with the prefix {{prefix}}",
      "notFound": "No supplier records were found with the prefix {{prefix}}"
    },
    "buttons": {
      "cancel": "Cancel",
      "import": "Import"
    }
  },
  "changeControlAlerts": {
    "approvalDeclined": "Approval declined",
    "approvalPreviouslyDeclined": "Approval previously declined",
    "declinedMessage": "{{name}} declined to approve this supplier on {{date}} with the following reason: \"{{reason}}\""
  },
  "statusChangeModal": {
    "approveTitle": "Approve supplier",
    "rejectTitle": "Reject supplier",
    "approveMessage": "Enter your password to approve this supplier.",
    "rejectMessage": "Enter your password to reject this supplier.",
    "fields": {
      "email": {
        "label": "Email",
        "error": "Please enter an email"
      },
      "password": {
        "label": "Password",
        "error": "Please enter a password"
      },
      "reason": {
        "label": "Reason for rejection",
        "error": "Please enter a reason to reject this supplier"
      }
    },
    "errors": {
      "fillRequiredFields": "Please fill out required fields",
      "somethingWentWrong": "Something went wrong",
      "requiredFields": "Please fill out required fields",
      "generic": "Something went wrong",
      "email": "Please enter an email",
      "password": "Please enter a password",
      "reason": "Please enter a reason to reject this supplier"
    },
    "buttons": {
      "cancel": "Cancel",
      "approve": "Approve",
      "reject": "Reject"
    }
  },
  "policyConfiguration": {
    "heading": "Policy Configuration",
    "tabs": {
      "supplierTypes": "Supplier types",
      "riskLevels": "Risk levels",
      "documentTypes": "Document types",
      "auditTypes": "Audit types"
    },
    "template": {
      "title": "You haven't defined any review types yet",
      "subtitle": "Specify what review types will be used in the Policy. Use the suggested template and edit them to suit your needs or create your own.",
      "useTemplate": "Use suggested {{name}} definitions",
      "buttons": {
        "useTemplate": "Use this template",
        "createFromScratch": "Create from scratch"
      },
      "divider": "or"
    },
    "configurationCard": {
      "placeholders": {
        "name": "Name",
        "addDescription": "Add description"
      }
    },
    "buttons": {
      "addNew": "Add a new",
      "cancel": "Cancel",
      "saveChanges": "Save changes"
    },
    "modals": {
      "saveChanges": {
        "title": "Save changes",
        "message": "Changes you made to supplier types will affect all existing suppliers of those supplier types. Make sure to review all affected suppliers and reassess them if needed.",
        "buttons": {
          "cancel": "Cancel",
          "save": "Save changes"
        }
      }
    }
  },
  "supplierPolicy": {
    "heading": "Supplier Policy",
    "buttons": {
      "configuration": "Configuration",
      "edit": "Edit",
      "export": "Export"
    },
    "tabs": {
      "requiredDocuments": "Required documents",
      "audits": "Audits"
    },
    "drawer": {
      "title": "Edit Policy",
      "sections": {
        "supplierType": "Supplier type",
        "riskLevel": "Risk level",
        "requiredDocuments": "Required documents",
        "audits": "Audits"
      },
      "descriptions": {
        "requiredDocuments": "The policy will require these documents to be added for a supplier to be approved.",
        "audits": "These audits will be required for all suppliers of this type and risk level."
      },
      "placeholders": {
        "addDocumentType": "Add document type",
        "addAuditType": "Add audit type",
        "dueEvery": "Due every"
      },
      "frequencyOptions": {
        "once": "Once",
        "monthsFromLastAudit": "{{count}} month(s) from last audit"
      },
      "noTypesFound": "{{type}} types are not yet defined in your supplier policy or you have selected all available options.",
      "warning": "Changes you make to the supplier policy will affect all existing suppliers of this type and risk level. Review all affected suppliers and re-evaluate them if needed.",
      "buttons": {
        "cancel": "Cancel",
        "save": "Save"
      }
    },
    "table": {
      "supplierType": "SUPPLIER TYPE",
      "riskLevel": "RISK LEVEL"
    }
  },
  "aslExport": {
    "coverPage": {
      "title": "Approved Supplier List",
      "generatedBy": "Generated by {{userName}}",
      "generatedWith": "Generated with",
      "qmsForLifeSciences": "QMS for Life Sciences",
      "website": "www.qualio.com"
    },
    "listPage": {
      "columns": {
        "supplierName": "Supplier Name",
        "type": "Type",
        "riskLevel": "Risk level",
        "intendedUse": "Intended use",
        "lastAudit": "Last audit",
        "auditDue": "Audit due"
      }
    }
  },
  "upSellViews": {
    "upgradeAccess": {
      "title": "Upgrade for access to Suppliers",
      "subtitle": "Your current Qualio plan does not include the new Suppliers feature. Contact your Customer Success representative to find out how to upgrade.",
      "button": "Learn more about Suppliers"
    },
    "insufficientPermissions": {
      "title": "Trying to do some supply chain work?",
      "subtitle": "Unfortunately, you currently don’t have access to the Suppliers module. Contact your admin so you can easily onboard, manage and continuously improve your supplier base.",
      "button": "Watch product video"
    },
    "starterView": {
      "title": "Trying to do some supply chain work?",
      "subtitle": "Unfortunately, you currently don’t have access to the Suppliers module. Contact our support team so you can easily onboard, manage and continuously improve your supplier base.",
      "buttons": {
        "contactSupport": "Contact Qualio support",
        "watchVideo": "Watch product video"
      }
    }
  },
  "emergencyBreak": {
    "title": "Suppliers is under maintenance",
    "subtitle": "We are currently doing maintenance work on Suppliers. Get some coffee and check back a little later. Get in touch if you have any questions."
  },
  "notFound": {
    "message": "You seem to be lost"
  },
  "privateRoute": {
    "unauthorizedTitle": "You don't have permission to access this",
    "unauthorizedSubtitle": "You must be signed in as a Quality User to view and edit supplier policies. If you need access, contact your quality team."
  },
  "navigation": {
    "tabs": {
      "supplier": "Supplier",
      "policy": "Policy"
    }
  },
  "statuses": {
    "approved": "Approved",
    "pending": "Pending",
    "rejected": "Rejected",
    "draft": "Draft",
    "archived": "Archived"
  },
  "toastMessages": {
    "supplier": {
      "archived": "Archived",
      "archivedDescription": "{{name}} was archived",
      "archiveFailed": "Failure",
      "archiveFailedDescription": "Supplier not archived",
      "failure": "Failure",
      "notArchived": "Supplier not archived",
      "unArchived": "Unarchived",
      "unArchivedDescription": "{{name}} was unarchived",
      "notUnArchived": "Supplier was not unarchived",
      "unarchived": "Un Archived",
      "unarchivedDescription": "{{name}} was unarchived",
      "unarchiveFailed": "Failure",
      "unarchiveFailedDescription": "Supplier was not unarchived",
      "reverted": "Reverted",
      "revertedDescription": "{{name}} was reverted to draft",
      "revertedToDraftDescription": "{{name}} was reverted to draft",
      "notRevertedToDraft": "Supplier was not reverted to draft",
      "revertFailed": "Failure",
      "revertFailedDescription": "Supplier was not reverted to draft",
      "saved": "Saved",
      "savedAsDraft": "{{name}} was saved as draft.",
      "savedAsDraftDescription": "{{name}} was saved as draft.",
      "notSavedAsDraft": "Supplier was not saved as a draft",
      "notSentForApproval": "Supplier was not sent for approval",
      "sent": "Sent",
      "sentForApproval": "{{name}} was sent for approval",
      "sentForApprovalDescription": "{{name}} was sent for approval",
      "saveFailed": "Failure",
      "saveFailedDescription": "Supplier was not saved as a draft.",
      "fileReady": "File Ready",
      "fileReadyDescription": "The file is now available to",
      "download": "download",
      "exportFailed": "Failure",
      "exportFailedDescription": "Supplier not exported",
      "notExported": "Supplier not exported",
      "revertedToDraft": "{{name}} was reverted to draft",
      "revertToDraftFailed": "Supplier not reverted to draft",
      "preparingFile": "Preparing file for download",
      "preparingFileDescription": "We'll let you know when the file is ready",
      "exportsFailed": "Suppliers not exported",
      "suppliersNotExported": "Suppliers not exported"
    },
    "audit": {
      "added": "Audit added",
      "creationFailed": "Audit creation Failed",
      "creationFailedDescription": "Failed to attach audit to the supplier",
      "updated": "Audit updated",
      "updateFailed": "Audit update failed",
      "updateFailedDescription": "Failed to update the audit",
      "deleted": "Audit deleted",
      "deletionFailed": "Audit deletion failed",
      "deletionFailedDescription": "Failed to delete audit from the supplier"
    },
    "config": {
      "configuration": "Configuration",
      "updated": "{{configType}} was updated",
      "updateFailed": "Configuration failed to update"
    },
    "policy": {
      "saved": "Policy saved",
      "savedDescription": "You may need to re-evaluate affected suppliers.",
      "saveFailed": "Failure",
      "saveFailedDescription": "Cannot save your policy."
    },
    "policyLinks": {
      "fetchFailed": "Something went wrong fetching your required supporting documents"
    },
    "import": {
      "success": "Import Successful",
      "successDescription": "Suppliers have been imported successfully",
      "failed": "Import Failed",
      "failedDescription": "Failed to import suppliers"
    },
    "approval": {
      "completed": "Approval action completed"
    },
    "document": {
      "downloadError": "Error",
      "downloadErrorDescription": "Something wrong happened downloading this document"
    },
    "export": {
      "error": "Error",
      "errorDescription": "No approved suppliers to export",
      "policyLinksError": "Cannot retrieve policy links",
      "supplierExportToast": "{{name}} export",
      "configExportToast": "Supplier configuration export"
    }
  },
  "common": {
    "buttons": {
      "cancel": "Cancel",
      "save": "Save",
      "delete": "Delete",
      "edit": "Edit",
      "close": "Close",
      "review": "Review",
      "ok": "Ok",
      "gotIt": "Got it"
    },
    "placeholders": {
      "noData": "--"
    },
    "ariaLabels": {
      "deleteDescription": "delete-description",
      "downloadFile": "Download file",
      "openQualioDoc": "Open qualio doc",
      "deleteFile": "Delete file",
      "deletePolicyRow": "Delete policy row",
      "viewRelatedRecords": "View related records"
    },
    "misc": {
      "auditType": "Audit type:",
      "name": "Name:",
      "type": "Type:"
    }
  }
}
